import { put, call, takeLatest } from "@redux-saga/core/effects";
import { toolsAverageMoodApi, toolsMoodsLoggedApi, toolsThoughtsLoggedApi, toolsTopUsageApi, } from "../Api/api";
import {
    toolsAverageMoodFail,
    toolsAverageMoodLoad,
    toolsAverageMoodSuccess,
    toolsMoodsLoggedFailed,
    toolsMoodsLoggedLoad,
    toolsMoodsLoggedSuccess,
    toolsThoughtsLoggedFailed,
    toolsThoughtsLoggedLoad,
    toolsThoughtsLoggedSuccess,
    toolsTopUsageFail,
    toolsTopUsageLoad,
    toolsTopUsageSuccess,
} from "../slices/tools.slice";
import { toast } from "react-toastify";
import appconstant from "../../themes/appconstant";

function* toolsMoodsLoggedSaga(action) {
    try {
        const data = yield call(toolsMoodsLoggedApi, action.payload);
        if (data.status === 0) {
            yield put(toolsMoodsLoggedSuccess(data.result.data));
        } else if (data.status === 2) {
            toast.success(data?.result?.message);
            localStorage.clear();
        } else {
            toast.error(appconstant.serverError);
            yield put(toolsMoodsLoggedFailed());
        }
    } catch (e) {
        toast.error(appconstant.serverError);
        yield put(toolsMoodsLoggedFailed());
    }
}

function* toolsThoughtsLoggedSaga(action) {
    try {
        const data = yield call(toolsThoughtsLoggedApi, action.payload);
        if (data.status === 0) {
            yield put(toolsThoughtsLoggedSuccess(data.result.data));
        } else if (data.status === 2) {
            toast.success(data?.result?.message);
            localStorage.clear();
        } else {
            toast.error(appconstant.serverError);
            yield put(toolsThoughtsLoggedFailed());
        }
    } catch (e) {
        toast.error(appconstant.serverError);
        yield put(toolsThoughtsLoggedFailed());
    }
}

function* toolsAverageMoodSaga(action) {
    try {
        const data = yield call(toolsAverageMoodApi, action.payload);
        if (data.status === 0) {
            yield put(toolsAverageMoodSuccess(data.result.data));
        } else if (data.status === 2) {
            toast.success(data?.result?.message);
            localStorage.clear();
        } else {
            toast.error(appconstant.serverError);
            yield put(toolsAverageMoodFail());
        }
    } catch (e) {
        toast.error(appconstant.serverError);
        yield put(toolsAverageMoodFail());
    }
}


function* toolsTopUsageSaga(action) {
    try {
        const data = yield call(toolsTopUsageApi, action.payload);
        if (data.status === 0) {
            yield put(toolsTopUsageSuccess(data.result));
        } else if (data.status === 2) {
            localStorage.clear();
            toast.success(data?.result?.message);
        } else {
            toast.error(appconstant.serverError);
            yield put(toolsTopUsageFail());
        }
    } catch (e) {
        toast.error(appconstant.serverError);
        yield put(toolsTopUsageFail());
    }
}

export default function* rootToolsSaga() {
    yield takeLatest(toolsMoodsLoggedLoad.type, toolsMoodsLoggedSaga);
    yield takeLatest(toolsThoughtsLoggedLoad.type, toolsThoughtsLoggedSaga);
    yield takeLatest(toolsAverageMoodLoad.type, toolsAverageMoodSaga);
    yield takeLatest(toolsTopUsageLoad.type, toolsTopUsageSaga);




}
